const {
  VITE_HARVESTAPP_V2_API_URL: HARVESTAPP_V2_API_URL,
  VITE_HARVESTAPP_PLATFORM_HOST: HARVESTAPP_PLATFORM_HOST,
  VITE_HARVEST_ID_HOST: HARVEST_ID_HOST,
  VITE_SCHEME: SCHEME,
} = import.meta.env

const scheme = SCHEME || 'https'

export const baseUrl = `${scheme}://${HARVESTAPP_PLATFORM_HOST}`
export const idBaseUrl = `${scheme}://${HARVEST_ID_HOST}`
export const apiBaseUrl = `${scheme}://${HARVESTAPP_V2_API_URL}`

const accountsUrlQueryString = new URLSearchParams({
  filter_product: 'harvest',
  return_to: encodeURI(`${baseUrl}/platform/success?v2=true`),
})
export const accountsUrl = `${idBaseUrl}/accounts?${accountsUrlQueryString}`

// If the user has one account,
// /harvest/sign_in will automatically redirect to it
// If the user has many accounts,
// /harvest/sign_in will redirect to the accounts page (accountsUrls)
export const signInUrl = `${idBaseUrl}/harvest/sign_in?${accountsUrlQueryString}`

export const accountUrl = (accountId, returnTo) =>
  `${idBaseUrl}/accounts/${accountId}?return_to=${returnTo}`

export const buildTimesheetUrl = (baseUri) => new URL('/timesheet', baseUri)
